<script lang="ts">
    
    import type { GameType } from "../../global";

    export let type: GameType;

    const types: Record<GameType, string> = {
        'Bingo90'               : 'Binfun 90',
        'Bingo75'               : 'Binfun 75',
        'BingoMex'              : 'Lotería mexicana',
        'BingoAnimals'          : 'Binfun animales',
        'BingoCartoon'          : 'Binfun caricaturas',
        'Movies'                : 'Binfun películas',
        'MoviesKids'            : 'Binfun películas kids',
        'XMas'                  : 'X-Mas',
        'Football'              : 'Football',
        'Halloween'             : 'Halloween',
        'Superheroes'           : 'Superheroes',
        'Cartoon'               : 'Binfun Cartoon',
        'Music'                 : 'Binfun Music',
        'Canary'                : 'Binfun Canary Islands',
        'MusicReggaeton'        : 'Binfun Music Reggaeton',
        'BingoDominicano'       : 'Lotería dominicana',
        'BingoIberostar'        : 'Binfun Iberostar',
        'MusicWinterEnglish'    : 'Binfun Music Winter English',
        'MusicWinterSpanglish'  : 'Binfun Music Winter Spanglish',
    };

</script>

{types[type]}
